import React from "react";
import styled from "styled-components";

export interface Props extends React.HTMLAttributes<HTMLElement> {
  /** Align the elements vertically */
  vertical?: boolean;
  /** Align the elements vertically centered */
  verticalCenter?: boolean;
  /** Align the elements horizontally centered */
  horizontalCenter?: boolean;
  /** Center the elements */
  center?: boolean;
  /** Use a dynamic spacing between elements */
  justify?: boolean;
  /** Justify all elements around */
  justifyAround?: boolean;
  /** Use a fixed spacing between elements */
  spaced?: boolean;
  /** Use a wide fixed spacing between elements */
  spacedWide?: boolean;
  /** Set the container to use full width */
  fullWidth?: boolean;
  /** Set the container to user full height */
  fullHeight?: boolean;
  /** Set the container to place elements from right to left */
  right?: boolean;
}

/**
 * Flexbox helper classes enable you to quickly layout items in relation to each other.
 */
const FlexContainer = ({
  vertical,
  verticalCenter,
  horizontalCenter,
  center,
  justify,
  justifyAround,
  spaced,
  spacedWide,
  fullWidth,
  fullHeight,
  children,
  right,
  ...props
}: Props) => {
  return <div {...props}>{children}</div>;
};

export default styled(FlexContainer)<Props>`
  display: flex;
  flex-direction: ${getFlexDirection};
  align-items: ${getAlignItems};
  justify-content: ${getJustifyContent};
  margin-right: ${getMarginRight};
  height: ${(props) => props.fullHeight && `100%`};
  width: ${(props) => props.fullWidth && `100%`};
`;

function getAlignItems(props: Props) {
  if (props.verticalCenter || props.center) {
    return `center`;
  }
}

function getFlexDirection(props: Props) {
  if (props.vertical) {
    return `column`;
  } else if (props.right) {
    return `row-reverse`;
  }
}

function getJustifyContent(props: Props) {
  if (props.horizontalCenter || props.center) {
    return `center`;
  } else if (props.justify) {
    return `space-between`;
  } else if (props.justifyAround) {
    return `space-around`;
  }
}

function getMarginRight(props: Props) {
  const marginDirection = props.vertical ? "margin-bottom" : "margin-right";
  if (props.spaced) {
    return (
      marginDirection +
      `: 0.8rem;
    & > *:not(:last-child) {
      ` +
      marginDirection +
      `: 0.8rem;
    }`
    );
  } else if (props.spacedWide) {
    return (
      marginDirection +
      `
    : 1.6rem; 
    & > *:not(:last-child) {
      ` +
      marginDirection +
      `: 1.6rem;
    }
    `
    );
  }
}
